import { Event } from '@eencloud/eewc-components/src/service/api-types';

export type ExtendedEvent = Event & {
  startTimestampEpoch: number;
  endTimestampEpoch: number;
  startPos?: number;
  endPos?: number;
  width?: number;
};

export enum Action {
  Next = 'next',
  Previous = 'previous',
}

export enum PlayBackMode {
  Main = 'main',
  Preview = 'preview',
}

export interface EventGroup {
  type: 'overlay' | 'timeline';
  title: string;
  order: number;
}

export interface EventType {
  type: string;
  name: string;
  value: boolean;
  disabled: boolean;
  group: EventGroup;
}
